import { createAction } from '@reduxjs/toolkit';
import type {
  EntityAccessInvitation, EntityAccessInvitationId,
} from '~/_shared/entityAccess/entityAccess.invitations.repository';

export const entityAccessReceivedInvitationsChanged = createAction(
  'FRONTEND_STATE_ENTITY_ACCESS_RECEIVED_INVITATIONS_CHANGED',
  () => ({
    payload: {},
  })
);

export const entityAccessSetReceivedInvitations = createAction(
  'FRONTEND_STATE_SET_RECEIVED_ENTITY_ACCESS_INVITATIONS',
  (newInvitations: ReadonlyArray<EntityAccessInvitation>) => ({
    payload: { newInvitations },
  })
);

export const entityAccessSetDeleteReceivedInvitations = createAction(
  'FRONTEND_STATE_DELETE_RECEIVED_ENTITY_ACCESS_INVITATIONS',
  (ids: Set<EntityAccessInvitationId>) => ({
    payload: { ids },
  })
);
